export default "__VITE_ASSET__pP1PWnk4__"